import React, { useState, useEffect } from 'react';
import {
  Header,
  Sidebar,
  Breadcrumb,
  FormDynamic,
  NotifyBox,
  Footer,
} from '../../components';
import Loading from '../../components/loading';
import RDP_CONFIG from '../../config/config';
import { formatBody } from '../../utils/formatBody';
import axios from 'axios';

export default function NewAdmin({ consumer, history, match }) {
  const [entity, setEntity] = useState();
  const [defaultValues, setDefaultValues] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState('');
  const [msgError, setMsgError] = useState('');

  async function getFormFields() {
    const response = await fetch('./preferences.json');

    const { forms } = await response.json();

    setEntity(forms['edit-administrator']);
  }

  async function getAdminByUid(uid) {
    const response = await axios.get(
      `http://localhost:3333/administrators?uid=${uid}`
    );

    const defaultValues = await handleDefaultValues(response.data);

    setDefaultValues(defaultValues);
  }

  async function handleDefaultValues(user) {
    let body = await formatBody(user[0], entity.defaultValuesModel);

    return body;
  }

  useEffect(() => {
    getFormFields();
    consumer.defineRoute({
      name: 'Editar Administrador',
      path: 'administrators/:id',
    });
  }, []);

  useEffect(() => {
    if (entity) getAdminByUid(match.params.uid);
  }, [entity]);

  async function handleSubmit(dataForm) {
    console.log(dataForm);
  }

  return (
    <>
      {entity ? (
        <div className="rdp-admin-new-entity">
          <Header />
          <Sidebar
            currentRoute="/administrators/:uid"
            defineGroup={consumer ? consumer.defineGroup : null}
            defineRoute={consumer ? consumer.defineRoute : null}
            groups={consumer ? consumer.groups : null}
          />
          <Breadcrumb currentRoute={consumer ? consumer.currentRoute : null} />
          <div id="rdp-admin-content-area" className="rdp-admin-content">
            {loadingSubmit && <Loading msg="Enviando..." />}
            {!loadingSubmit && msgSuccess && (
              <NotifyBox
                type="success"
                onClose={() => setMsgSuccess('')}
                message={msgSuccess}
              />
            )}
            {!loadingSubmit && msgError && (
              <NotifyBox
                type="error"
                onClose={() => setMsgError('')}
                message={msgError}
              />
            )}
            <div className="test">
              {entity && (
                <FormDynamic
                  blocked={false}
                  values={defaultValues}
                  submitText={entity.submitText}
                  isNew={false}
                  cleanValues={false}
                  handleSubmit={(e) => handleSubmit(e.data)}
                  entity={entity}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <Loading msg="Montando Formulário..." />
      )}
      <Footer />
    </>
  );
}
